import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "form", "clearButton"]
  static values = {
    debounceMs: { type: Number, default: 500 },
  }

  connect() {
    this.timeout = null
    this.updateClearButtonVisibility()
  }

  // The input carries data-turbo-permanent, so after a frame render Turbo re-inserts it AFTER
  // this controller has already reconnected — connect() alone runs too early to see it, and the
  // freshly rendered clear button would stay hidden even though the search box holds a term.
  inputTargetConnected() {
    this.updateClearButtonVisibility()
  }

  search() {
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => {
      this.formTarget.requestSubmit()
    }, this.debounceMsValue)
    this.updateClearButtonVisibility()
  }

  clear() {
    this.inputTarget.value = ""
    this.updateClearButtonVisibility()
    this.formTarget.requestSubmit()
  }

  // Both targets are checked: connect() can run while the permanent input is still detached,
  // and inputTargetConnected re-runs this once it is in place.
  updateClearButtonVisibility() {
    if (!this.hasClearButtonTarget || !this.hasInputTarget) return

    const hasValue = this.inputTarget.value.length > 0
    this.clearButtonTarget.classList.toggle("hidden", !hasValue)
  }

  // Handle enter key
  submitOnEnter(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      clearTimeout(this.timeout)
      this.formTarget.requestSubmit()
    }
  }
}
